export const isViteDevMode = () => import.meta.env.DEV;
